module.exports = __webpack_public_path__ + "static/Serverless-05ccc66baab603c711f1f1a24ff535d5.svg";